import React, { Component } from "react";
import GravityForm from "react-gravity-form";
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';

export default class Enquire extends Component {
	
	constructor(){
		super()
		this.handleToggle 		= this.handleToggle.bind(this);
	}
    
    handleToggle(el) {
	    let title = el.getAttribute('data-title');  
	    document.getElementById('input_11_6').readOnly = false;
	    document.getElementById('input_11_6').value = title;
	    var event = new Event('blur');
	    document.getElementById('input_11_6').dispatchEvent(event);
		document.getElementById('input_11_6').readOnly = true;
		document.body.classList.add('state-enquire-open');
	    document.body.classList.remove('state-menu-open');
    }
    
	render () {
		
		let title = this.props.title;
	    return (
		    
		    <a href="#" className="c-subheading c-subheading--reverse" onClick={(e) => (e.preventDefault(), this.handleToggle(e.currentTarget))} data-title={title}><span className="c-subheading__line">Enquire</span></a>
		    
		)

	}
}
